import {ExcelWorksheet} from 'common/src/modules/excel/excel.types';
import {z} from 'zod';
import invokeStandaloneLLMCall from './invokeStandaloneLLMCall';
import openAISystemMessage from '../openAI/utils/openAISystemMessage';

const excelHeaderInfoSchema = z.object({
  title: z.string().describe('The title of the column header'),
  rowIndex: z.number().describe('The row number of the header row (index starts at 0)'),
  columnIndex: z.number().describe('The column number of the header row (index starts at 0)'),
  subHeaderOf: z
    .number()
    .describe('The row index of the header row that this header is a sub-header of')
    .nullable(),
});

const analyzeWorksheetHeadersSchema = z.object({
  headers: z
    .array(excelHeaderInfoSchema)
    .describe(
      'Info about the excel header rows. There may be multiple header rows, where a higher header has merged cells and the lower header is its sub-header row.',
    ),
});

export default async function analyzeWorksheetHeaders(
  worksheet: ExcelWorksheet,
  abortSignal: AbortSignal,
): Promise<z.infer<typeof excelHeaderInfoSchema>[]> {
  const SAMPLE_ROWS_COUNT = 15;
  const sampleRows = worksheet.rows.slice(0, SAMPLE_ROWS_COUNT);

  const instructions = `Analyze the following excel worksheet.
  Attempt to recognize as many header rows as possible.
  
  First ${sampleRows.length} rows of the worksheet:
  ${JSON.stringify(sampleRows, null, 1)}
  `;

  const aiResponse = await invokeStandaloneLLMCall({
    messages: [openAISystemMessage(instructions)],
    responseSchema: analyzeWorksheetHeadersSchema,
    abortSignal,
  });

  if (!aiResponse.headers) {
    return [];
  }

  return aiResponse.headers;
}
